import React from 'react';
import { SISTEMA_OPERACIONAL_LABELS } from '../../../SolicitacaoDetailsPage/solicitacaoDetailsPage.definitions';
import { TIPOS_COMPUTADOR, TIPOS_COM_SO } from './ativos.definitions';
import type { FormFichaAtivo } from './ativoFicha.form';

interface AtivoCamposTipoProps {
  form: FormFichaAtivo;
  onChange: (campo: keyof FormFichaAtivo, valor: string) => void;
}

function Campo({
  label,
  campo,
  form,
  onChange,
  tipo = 'text',
}: {
  label: string;
  campo: keyof FormFichaAtivo;
  tipo?: string;
} & AtivoCamposTipoProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <input
        type={tipo}
        className="input-primary mt-1 w-full"
        value={form[campo]}
        onChange={(event) => onChange(campo, event.target.value)}
      />
    </div>
  );
}

/**
 * Campos que só existem em alguns tipos (discovery §5): computador (SO + componentes),
 * smartphone (SO), chip (linha/operadora/MSIN/PIN/PUK), cartão de acesso (nº do cartão).
 * Monitor e impressora ficam só com a base. PIN/PUK: a tela inteira já é exclusiva do SI.
 */
export default function AtivoCamposTipo({ form, onChange }: AtivoCamposTipoProps) {
  const props = { form, onChange };
  const temSo = TIPOS_COM_SO.includes(form.tipo);
  const ehComputador = TIPOS_COMPUTADOR.includes(form.tipo);

  if (!temSo && form.tipo !== 'chip' && form.tipo !== 'cartao_acesso') return null;

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {temSo && (
        <div>
          <label className="block text-sm font-medium text-gray-700">Sistema operacional</label>
          <select
            className="input-primary mt-1 w-full"
            value={form.sistemaOperacional}
            onChange={(event) => onChange('sistemaOperacional', event.target.value)}
          >
            <option value="">Selecione...</option>
            {Object.entries(SISTEMA_OPERACIONAL_LABELS).map(([valor, label]) => (
              <option key={valor} value={valor}>
                {label}
              </option>
            ))}
            {/* Valor vindo de outra origem (ex.: OCS/GLPI) que não está no catálogo. */}
            {form.sistemaOperacional && !(form.sistemaOperacional in SISTEMA_OPERACIONAL_LABELS) && (
              <option value={form.sistemaOperacional}>{form.sistemaOperacional}</option>
            )}
          </select>
        </div>
      )}
      {ehComputador && (
        <>
          <Campo label="Processador" campo="processador" {...props} />
          <Campo label="Memória RAM" campo="memoria" {...props} />
          <Campo label="Armazenamento" campo="tamanhoDisco" {...props} />
        </>
      )}
      {form.tipo === 'chip' && (
        <>
          <Campo label="Linha" campo="linha" {...props} />
          <Campo label="Operadora" campo="operadora" {...props} />
          <Campo label="MSIN" campo="msin" {...props} />
          <Campo label="PIN 1" campo="pin1" {...props} />
          <Campo label="PUK 1" campo="puk1" {...props} />
          <Campo label="PIN 2" campo="pin2" {...props} />
          <Campo label="PUK 2" campo="puk2" {...props} />
        </>
      )}
      {form.tipo === 'cartao_acesso' && <Campo label="Número do cartão" campo="numeroCartao" {...props} />}
    </div>
  );
}
